import { getCookie } from './cookieHelper';
import { DE_LOCALE } from './i18n';

export const isIwocaDE = () => {
  const host = window.location.host;

  const isDELocale =
    hostIncludesDeLocale(host) || getCookie('locale') === DE_LOCALE;

  return isDELocale;
};

// Whether a host or URL points at the DE locale (e.g. iwoca.de,
// stage.iwoca-dev.de). Also used to derive the locale from the dev proxy
// target — see useEnvProxyForLocale.
export const hostIncludesDeLocale = (host?: string) => {
  if (!host) return false;

  return host.includes(`.${DE_LOCALE}`);
};
